<template>
  <transition name="fade">
    <div v-if="currentVideo" :id="'player-' + $store.getters.appID" class="player">
      <youtube 
        v-if="currentVideo.type == 'YouTubeVideo'" 
        :video-id="'video-' + currentVideo.id" 
        :player-vars="{rel: 0, origin: 'https://smmc.mountainhealthnetwork.org', autoplay: autoplay}" 
        :player-width="'100%'" 
        :host="host" 
        @ready="playerReady">
      </youtube>
      <!-- <div class="curr-video-info"><strong>Now playing: {{currVideo.title}}</strong></div> -->
      <media 
        v-else 
        :kind="'video'" 
        :controls="true" 
        :src="currentVideo.video_url" 
        :poster="currentVideo.poster_img.large" 
        :autoplay="autoplay" 
        :width="'100%'" 
        :ref="'video_player'"
        @loadeddata="playerReady">
      </media>
    </div>
  </transition>
</template>

<script>
  
  import Media from '@dongido/vue-viaudio';

  export default {
    name: 'Player',
    components: {
      Media
    },
    data() {
      return {
        host: 'https://www.youtube-nocookie.com'
      }
    },
    methods: {
      playerReady() {
        this.$store.commit('playerReady', true)
      }
    },
    computed: {
      currentVideo () {
        return this.$store.getters.currentVideo
      },
      autoplay () {
        return this.$store.getters.autoplay
      },
      playerOptions () {
        return {

        }
      }
    }
  }
</script>
